module.exports = __webpack_public_path__ + "static/media/Rectangle 191.027cecdd.svg";